import { Anchor, Center, Group, ScrollArea, Stack, Text } from '@mantine/core';
import { IconCloudOff } from '@tabler/icons-react';
import { useUploadStore } from '../uploadStore';
import { UploadFileItem } from './UploadFileItem';

interface UploadFileListProps {
  onCancel: (uppyFileId: string) => void;
  onRetry: (uppyFileId: string) => void;
}

const ACTIVE_STATUSES = new Set(['pending', 'creating', 'uploading', 'processing']);

export function UploadFileList({ onCancel, onRetry }: UploadFileListProps) {
  const items = useUploadStore((s) => s.items);
  const clearCompleted = useUploadStore((s) => s.clearCompleted);

  if (items.length === 0) {
    return (
      <Center py="xl" style={{ flex: 1 }}>
        <Stack align="center" gap="xs">
          <IconCloudOff size={32} color="var(--mantine-color-gray-4)" />
          <Text size="sm" c="dimmed">
            No uploads yet
          </Text>
        </Stack>
      </Center>
    );
  }

  // Active items first, then terminal (ready/error/cancelled)
  const sorted = [...items].sort((a, b) => {
    const aActive = ACTIVE_STATUSES.has(a.status) ? 0 : 1;
    const bActive = ACTIVE_STATUSES.has(b.status) ? 0 : 1;
    return aActive - bActive;
  });

  const hasTerminal = items.some(
    (i) => i.status === 'ready' || i.status === 'error' || i.status === 'cancelled'
  );

  return (
    <Stack gap="xs" style={{ flex: 1, minHeight: 0 }}>
      {hasTerminal && (
        <Group justify="flex-end">
          <Anchor size="xs" onClick={clearCompleted}>
            Clear completed
          </Anchor>
        </Group>
      )}
      <ScrollArea style={{ flex: 1 }}>
        <Stack gap="xs">
          {sorted.map((item) => (
            <UploadFileItem
              key={item.id}
              item={item}
              onCancel={onCancel}
              onRetry={onRetry}
            />
          ))}
        </Stack>
      </ScrollArea>
    </Stack>
  );
}
